export enum BiddingStageEnum {
    draft = 7,
    published = 8,
    dispute = 9,
    decision = 10,
    finishing = 11,
}
